'use client'

import { useState } from 'react'
import { useRouter } from 'next/navigation'
import { toast } from '@/lib/toast'
import { createBalanceInvoiceApi, type PaymentEndpoint } from '@/lib/commerce/services/payment-api'

/*
  Split payment: raise an invoice for the outstanding balance from the order page.

  Deliberately does NOT render its own QR screen. On success it refreshes the route, the
  server re-fetches the order with order.qpay (or pocket/storepay/lend/omniway) populated, and the
  page falls through to the SAME rail block that renders a normal pending payment — which
  already shows getPayableAmount, i.e. the balance. One QR implementation, not two.

  Checking the payment needs no new endpoint either: the existing /order/payment/... route
  resolves which leg is outstanding server-side.
*/
export function useBalancePayment({ order, vendor, onRefresh }: { order: any, vendor: any, onRefresh?: () => void }) {
  const router = useRouter()
  const [loading, setLoading] = useState(false)

  const pay = async (method: PaymentEndpoint) => {
    if (!order?.customId || !order?.phone || !vendor?.id) {
      return toast.error('Захиалгын мэдээлэл дутуу байна')
    }
    setLoading(true)
    const result = await createBalanceInvoiceApi(order.customId, order.phone, vendor.id, method)
    setLoading(false)
    // sendRequestAuto returns `false` outright on a non-OK response.
    if (!result) return toast.error('Нэхэмжлэл үүсгэхэд алдаа гарлаа')
    const { data, error } = result
    if (error) return toast.error(error)
    if (!data) return toast.error('Нэхэмжлэл үүсгэхэд алдаа гарлаа')
    onRefresh?.()
    router.refresh()
  }

  return { loading, pay }
}
